import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

export function IaxAlertDialog({
  open,
  handleClose,
  handleConfirmAction,
  dialog_title,
  dialog_msg,
}) {
  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{dialog_title}</DialogTitle>
        <DialogContent>{dialog_msg}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="error" variant="contained">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmAction}
            color="primary"
            variant="contained"
            autoFocus
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
